import formBaseMixin         from '../../../components/form/form-base-mixin.js'
import userFriendlyEr        from '../../../utils/userFriendlyEr.js'
import { core, garbage }     from '@/api/api-endpoints'
import { garbageOffline }    from '@/api/api-offline-endpoints'
import year                  from '../../../utils/year.js'
import { STATUS_NOT_ACTIVE } from '@/config/config'
import { KRASNODAR }             from '@/config/region'
import region                from '../../../utils/region'
import documentsMixin        from '@/common/layout/documents/documentsMixin'
import OperatorTable         from '../components/operator-table.vue'
import RoutesTable           from '../components/routes-table.vue'
import GarbageTable          from '../components/garbage-table.vue'

const Okved = () => ({
  name: '',
  code: ''
})

export default {
  mixins:     [formBaseMixin, documentsMixin],
  components: {
    GarbageTable,
    OperatorTable,
    RoutesTable
  },
  data() {
    return {
      fields: {
        name:          '',
        short_name:    '',
        head_name:     '',
        head_position: '',
        fact_address:  '',
        legal_address: '',
        inn:           '',
        ogrn:          '',
        geo_lat:       '',
        geo_lon:       '',
        kpp:           '',
        okpo:          '',
        okved:         new Okved(),
        photo_id:      null
        
        // use for test
        // in http://localhost:8010/#/othodoobrazovateli/ip/create
        /* name: 'test',
         inn: 1,
         kpp: 2,
         status_id: 1,
         address_id: 71499,
         latitude: '56.8385216',
         longitude: '60.6054911',
         fact_address: 'г Екатеринбург' */
      }
    }
  },
  computed: {
    title() {
      if (!this.fields || !this.fields.id) {
        return this.$translate('Добавление новой записи')
      }
      let title = ``
      if (this.fields.name) {
        title += this.fields.name
      } else {
        title = this.$translate('Редактирование записи')
      }
      if ([2, 3, 6, 9].includes(this.fields.garbage_source_type_id)) {
        if (this.fields.inn && this.fields.inn !== '') {
          title += `<br>ИНН: ${this.fields.inn}`
        }
      }
      return title
    },
    showOperationInMedic() {
      return region.getCurrentRegion() === KRASNODAR
    },
    // used in hmao demo
    individualGarbageOperationCats() {
      return [392, 393, 394, 395]
    },
    notActive() {
      return STATUS_NOT_ACTIVE
    },
    business_categories() {
      return this.$store.getters.readUrlEndpoint(this.getBusinessCategoriesEndpoint()).business_category
    },
    statuses() {
      return this.$store.getters.readUrlEndpoint(this.getStatusEndpoint()).status
    },
    // https://redmine.etton.ru/issues/13590
    showPeopleCount() {
      return region.getCurrentRegion() !== KRASNODAR
    }
  },
  methods:  {
    getBusinessCategoriesEndpoint() {
      return core.statuses({ fields: 'business_category' })
    },
    getStatusEndpoint() {
      return core.statuses({ fields: 'status' })
    },
    getDeleteUrl(id) {
      return garbage.garbageDelete(id)
    },
    getUpdateOrCreateUrl() {
      return garbage.garbageUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return garbage.garbage(route.params.id)
    },
    // https://redmine.etton.ru/issues/13590
    filterAndRenameAttributeInCatsForMKDAndID(cats) {
      if (region.getCurrentRegion() === KRASNODAR) {
        let from = 'Количество проживающих'
        let to   = 'Количество прописанных'
        return cats.map(v => {
          if (v.calculationUnit && v.calculationUnit.attribute) {
            if (v.calculationUnit.attribute === from) {
              v.calculationUnit.attribute = to
              console.warn('calculationUnit.attribute renamed from', from, 'to', to)
              return v
            }
          }
          return v
        })
      }
      return cats
    },
    onSuccess(response, afterSaveResponse) {
      if (this.item && this.item.id) {
        this.showOnSuccess('Данные обновлены')
      } else {
        this.showOnSuccess('Запись сохранена')
      }
      this.unFreezeFrom()
      this.onSaveForm()
      if (this.onlyUpdate === true) {
        this.onlyUpdate = false
      } else {
        setTimeout(() => {
          this.$router.push(this.getRedirectParams())
        }, 0)
      }
    },
    msnUpdated() {
      if (this.fields.id) {
        this.onlyUpdate = true
        this.sendForm()
      }
    },
    additionalValidate: async function(hasError = false, errors = {}) {
      if (this.$refs.garbageOperation && this.$refs.garbageOperation.error) {
        this.tabView = this.$refs.garbageOperation.tabView
        return Promise.reject('Error in garbage operation')
      }
      return Promise.resolve(1)
    },
    getEditablesEndpointsAndUrl() {
      // garbages
      let years        = year.getYears()
      let operations   = ['input', 'output', 'detail']
      let postUrl      = []
      let tmpEndpoints = []
      for (let i = 0; i < years.length; i++) {
        for (let j = 0; j < operations.length; j++) {
          postUrl.push(garbage.garbageOperationPost({
                                                      query: {
                                                        sourceId: this.fields.id,
                                                        year:     years[i],
                                                        type:     operations[j]
                                                      }
                                                    }))
          tmpEndpoints.push(garbageOffline.garbageTable(this.$route.name, years[i], operations[j]))
          
          // add endpoint for medical table
          if (this.fields.garbage_source_type_id == 5) {
            postUrl.push(garbage.garbageOperationPost({
                                                        query: {
                                                          sourceId:               this.fields.id,
                                                          year:                   years[i],
                                                          type:                   operations[j],
                                                          garbage_source_type_id: 5
                                                        }
                                                      }))
            tmpEndpoints.push(garbageOffline.medicalTable(this.$route.name, years[i], operations[j]))
          }
        }
      }
      
      // add operator table
      postUrl.push(garbage.services({ query: {} }, this.fields.id))
      tmpEndpoints.push(garbageOffline.operatorTable(this.$route.name))
      
      // add operator medic table
      if (this.fields.garbage_source_type_id == 5) {
        postUrl.push(garbage.servicesMed({ query: {} }, this.fields.id))
        tmpEndpoints.push(garbageOffline.operatorMedicTable(this.$route.name))
      }
      // add houses tab
      postUrl.push(garbage.garbageHousePost({
                                              query: {
                                                sourceId: this.fields.id
                                              }
                                            }))
      tmpEndpoints.push(garbageOffline.houseTable(this.$route.name))
      
      return { postUrl, tmpEndpoints }
    },
    afterSave: async function() {
      let errors = []
      
      if (!this.$route.params.id) {
        // save garbage and medical table for new records
        let { postUrl, tmpEndpoints } = this.getEditablesEndpointsAndUrl()
        
        for (let i = 0; i < tmpEndpoints.length; i++) {
          if (this.$store.getters.readUrlEndpoint(tmpEndpoints[i])) {
            let data = this.$store.getters.readUrlEndpoint(tmpEndpoints[i]).data
            for (let j = 0; j < data.length; j++) {
              if (data[j]._isValid === true && data[j]._considerSaved === true) {
                try {
                  await this.$store.dispatch('createModel', {
                    url:      postUrl[i],
                    endpoint: tmpEndpoints[i],
                    data:     data[j]
                  })
                } catch (e) {
                  console.log(e)
                  errors.push(userFriendlyEr.recognize(e))
                }
              } else {
                console.warn('Invalid row', data[j])
              }
            }
          }
        }
      }
      
      // save operations
      if (!this.fields.operations) {
        this.fields.operations = []
      }
      for (let i = 0; i < this.fields.operations.length; i++) {
        let data = Object.assign({}, this.fields.operations[i])
        try {
          await this.$store.dispatch('updateModel', {
            url:  garbage.garbageOperationNorm(this.fields.id, data.year),
            data: data
          })
        } catch (e) {
          console.log(e)
          errors.push('Нормативы: ' + userFriendlyEr.recognize(e))
        }
      }
      
      if (errors.length > 0) {
        console.log(errors)
        return Promise.reject(errors.join('<br><br>'))
      }
      
      return Promise.resolve(1)
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        if (this.fields.okved !== 'object') {
          console.warn('Unknown format of okved, okved was reseted', this.fields.okved)
          this.fields.okved = new Okved()
        }
        this.fields = Object.assign({}, this.fields)
      }
    },
    fileUploaded({ id }) {
      this.fields.photo_id = id
    },
    fileRemoved() {
      this.fields.photo_id = null
    },
    uploadUrl() {
      return core.file()
    }
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', { endpoint: methods.getItemEndpoint(route, fromRoute) }))
    }
    
    if (methods.getStatusEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint:  methods.getStatusEndpoint(),
        fromCache: true
      }))
    }
    if (methods.getBusinessCategoriesEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint:  methods.getBusinessCategoriesEndpoint(),
        fromCache: true
      }))
    }
    
    if (promises.length === 0) {
      return Promise.resolve(1)
    }
    
    return Promise.all(promises)
  }
}

